import { getTZOffset } from '@mote/helpers'
import { apiClient } from '../../../client'
import { useGenericRequestHandler } from '../../../handlers'
import type { GenericHandlerValues, MoteStatus } from '../../../models'

const ENDPOINT = 'v1/m/edit'
let abortController: AbortController | null = null

export type UseMoteEditMutationValues = GenericHandlerValues<
  { moteStatus: MoteStatus },
  'POST'
>

export const useMoteEditMutation = (moteId: string) => {
  return useGenericRequestHandler({
    route: `${ENDPOINT}/${moteId}`,
    enabled: Boolean(moteId),
    method: 'POST',
    options: {
      timeout: 30000,
      json: {
        TZOffset: getTZOffset()
      }
    }
  }) as UseMoteEditMutationValues
}

export interface MoteEditRowOptions {
  moteId?: string
  abortable?: boolean
  variables?: Record<string, unknown>
}

export function moteEditRaw(options: MoteEditRowOptions = {}) {
  const { moteId, abortable = true, variables = {} } = options
  const defaultOptions: { signal?: AbortSignal } = {}

  if (!moteId) return

  if (abortable) {
    if (abortController) abortController.abort()
    abortController = new AbortController()
    defaultOptions.signal = abortController.signal
  }

  return apiClient
    .extend({
      timeout: 30000
    })
    .post(`${ENDPOINT}/${moteId}`, {
      ...defaultOptions,
      json: { ...variables, TZOffset: getTZOffset() }
    })
    .then(response => response.json())
    .catch(error => ({ error }))
}
